<template>
	<ja-modal class="add-messsage-modal" :show="show">
		<ja-close-button name="close" @click.native="closeModal"></ja-close-button>

		<div class="modal-content">
			<h1>{{ $t('newMessage') }}</h1>
			<ja-dropdown
				v-model="selectedMessage"
				:label="$t('predefinedTextLabel')"
				:placeholder="`${$t('select')}...`"
				:options="predefinedMessages"
				name="predefinedMessages"
				@input="onDropdownChange"
			></ja-dropdown>
			<ja-textarea
				v-if="showCustomInput"
				v-model="customMessage"
				:max-length="MESSAGE_TEXT_MAX_LENGTH"
				:label="$t('freeTextLabel')"
				:placeholder="$t('messagePlaceholder')"
				name="freeMsgText"
			></ja-textarea>
			<div class="button-wrapper">
				<ja-button
					class="small"
					:disabled="requestMade || buttonDisabled"
					name="sendMsg"
					@click.native="sendMessage"
					>{{ $t('send') }}</ja-button
				>
			</div>
		</div>
	</ja-modal>
</template>

<script>
import MessagesService from '@/services/MessagesService';
import '../../icons/expenseCategories';
import UserData from '@/mixins/UserData';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/ui/Button';
import Dropdown from '@/components/ui/form/Dropdown';
import Textarea from '@/components/ui/form/Textarea';
import CloseButton from '../../ui/CloseButton';

export default {
	components: {
		jaModal: Modal,
		jaDropdown: Dropdown,
		jaTextarea: Textarea,
		jaButton: Button,
		jaCloseButton: CloseButton
	},
	mixins: [UserData],
	props: {
		show: {
			type: Boolean,
			value: false
		}
	},
	data() {
		return {
			selectedMessage: null,
			predefinedMessages: [],
			customMessage: '',
			showCustomInput: false,
			requestMade: false,
			freeTextRolePermissions: ['1', '2', '3', '4'] // National Admin, USA Admin, Area Admin, JA Staff
		};
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		},
		MESSAGE_TEXT_MAX_LENGTH() {
			if (this.constants) {
				return this.constants.messageTextMaxLength;
			}
			return null;
		},
		buttonDisabled() {
			if (this.selectedMessage === null) {
				return true;
			} else if (
				this.predefinedMessages[this.selectedMessage].value == 'Free Text'
			) {
				return !this.customMessage.trim();
			} else {
				return false;
			}
		}
	},
	created() {
		MessagesService.getPredefinedMessages().then(messages => {
			const predefinedMessages = [];
			if (this.freeTextRolePermissions.includes(this.userData.roleId)) {
				predefinedMessages.push({
					name: this.$t('freeText'),
					value: 'Free Text'
				});
			}

			messages.forEach(msg => {
				predefinedMessages.push({ name: msg.text, value: msg.text });
			});

			this.predefinedMessages = predefinedMessages;
		});
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
			this.selectedMessage = null;
			this.customMessage = '';
			this.showCustomInput = false;
		},
		onDropdownChange(value) {
			if (value >= 0 && this.predefinedMessages[value].value == 'Free Text') {
				this.showCustomInput = true;
			} else {
				this.showCustomInput = false;
				this.customMessage = '';
			}
		},
		async sendMessage() {
			if (
				this.selectedMessage !== null ||
				(this.predefinedMessages[this.selectedMessage].value == 'Free Text' &&
					this.customMessage.trim())
			) {
				this.requestMade = true;
				const message =
					this.predefinedMessages[this.selectedMessage].value == 'Free Text'
						? this.customMessage
						: this.predefinedMessages[this.selectedMessage].name;

				MessagesService.send(this.userData.userId, message).then(() => {
					this.requestMade = false;
					this.closeModal();
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.add-messsage-modal {
	.close-button {
		background-color: $font-blue;
		position: absolute;
		height: 38px;
		width: 38px;
		right: 16px;
		top: 16px;
		outline: 0;
		border: 0;
		background-color: $container-bgcolor;
		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				svg {
					fill: $hover-state;
				}
			}
		}

		svg {
			fill: $primary-state;
		}
	}

	.modal-content {
		width: 66%;
		margin: 64px auto;
		display: flex;
		flex-direction: column;
		text-align: left;
		h1 {
			text-align: center;
		}

		.textarea {
			margin-top: 16px;
		}

		.button-wrapper {
			text-align: center;
			margin-top: 32px;
		}
	}
}
</style>
